import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import type { RouteEdgeInsertLabelProps } from './types';

const ROUTE_EDGE_SIZE_PX = 14;
// Stroke matches the planned route line color (ArcPolyline.future) so the handle reads as
// part of the route; 2px stroke over a 75%-opacity white fill, painted via the same
// HTML-overlay treatment as the waypoint pins (a Google Symbol/SVG-icon marker rendered solid).
const ROUTE_EDGE_COLOR = '#9E9EF3';

/** Single mid-edge insert point — HTML only, no stacked map markers. */
const RouteEdgeInsertLabel: React.FC<RouteEdgeInsertLabelProps> = ({ position }) => (
  <OverlayView position={position} mapPaneName={OverlayView.FLOAT_PANE}>
    <div
      style={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        width: ROUTE_EDGE_SIZE_PX,
        height: ROUTE_EDGE_SIZE_PX,
        boxSizing: 'border-box',
        borderRadius: '50%',
        border: `2px solid ${ROUTE_EDGE_COLOR}`,
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    />
  </OverlayView>
);

export default RouteEdgeInsertLabel;
